import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import SendIcon from "@material-ui/icons/Send";

import { styles } from "./ComunicacionItemStyles";

const externalLinks = [
  {
    name: "Envio individual",
    icon: SendIcon,
    cidiPath: "/portal/dashboard/comunicaciones/enviar",
  },
  {
    name: "Envio masivo",
    icon: SendIcon,
    cidiPath: "/portal/dashboard/comunicaciones/envio-masivo-email",
  },
  {
    name: "Estado envio masivo",
    icon: AccessTimeIcon,
    cidiPath: "/portal/dashboard/comunicaciones/estado-masivo-email",
  },
];

interface OwnProps {
  canAccessExternalLinks: boolean;
  handleDrawerToggle: () => void;
}
type PublicProps = OwnProps;
type Props = PublicProps & WithStyles<typeof styles>;

const ComunicacionItem: React.FC<Props> = (props) => {
  const { classes, canAccessExternalLinks, handleDrawerToggle } = props;
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith("/comunicaciones")) {
      setOpen(false);
    }
  }, [pathname]);

  const externalLinkHandler = (path: string) => {
    window.open(process.env.REACT_APP_CIDI + path, "_blank");
  };

  const isComunicacionesActive = pathname === "/comunicaciones";

  return (
    <>
      <ListItem
        button
        onClick={
          canAccessExternalLinks
            ? () => setOpen((prev) => !prev)
            : handleDrawerToggle
        }
        component={!canAccessExternalLinks ? NavLink : "li"}
        to={!canAccessExternalLinks ? "/comunicaciones" : undefined}
        className={
          !canAccessExternalLinks && isComunicacionesActive
            ? `${classes.listItem} ${classes.activeListItem}`
            : classes.listItem
        }
      >
        <ListItemIcon>
          <MailIcon />
        </ListItemIcon>
        <ListItemText primary="Comunicaciones" />
        {canAccessExternalLinks ? open ? <ExpandLess /> : <ExpandMore /> : null}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <NavLink
            to="/comunicaciones"
            style={{ textDecoration: "none", color: "inherit" }}
            key="comunicaciones"
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemIcon>
                  <AllInboxIcon />
                </ListItemIcon>
                <ListItemText primary="Recibidos" />
              </ListItem>
            )}
          </NavLink>

          {externalLinks.map((route: any, index: number) => (
            <ListItem
              key={index}
              button
              className={classes.nestedListItem}
              onClick={() => externalLinkHandler(route.cidiPath)}
            >
              <ListItemIcon>
                <route.icon />
              </ListItemIcon>
              <ListItemText primary={route.name} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default withStyles(styles)(
  ComunicacionItem
) as React.ComponentType<PublicProps>;
